module.exports = __webpack_public_path__ + "static/img/7.1b100ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/7.jpg
// module id = mmgF
// module chunks = 16